import { render, staticRenderFns } from "./Nutritions.vue?vue&type=template&id=1fa53ca3&scoped=true"
import script from "./Nutritions.vue?vue&type=script&lang=js"
export * from "./Nutritions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa53ca3",
  null
  
)

export default component.exports